<template>
    <div>
      <HeaderBar/>
      <div class="px-2" style="{backgruond-color:white}">
        <!-- search input -->
    
        <div class="d-flex justify-content-center headTitle mb-1 mt-4">Infraestructuras</div>
        <div class="d-flex justify-content-center headTitle mb-2">{{fincaName}}</div>
    
    
        <!-- table -->
        <vue-good-table :columns="columns" :rows="rows"
          :search-options="{
            enabled: false,
          }" 
          
          :pagination-options="{
            enabled: true,
            perPage: pageLength
          }"
          
        >
          <template slot="table-row" slot-scope="props">
    
            <!-- Column: Name -->
            <span v-if="props.column.field === 'action'" class="text-center">
              <a class="btn btn-danger btn-sm" @click="delStructure(props.row.id)"  v-if="!isAdmin()"><span class="fa fa-x"></span></a>
              <a class="btn btn-primary btn-sm" :href="'/advanceHome/datalog/infrastructure/'+props.row.id"  v-if="!isAdmin()"><span class="fa fa-pencil"></span></a>
            </span>
    
            <!-- Column: Common -->
            <span v-else>
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>
    
          <!-- pagination -->
          <template slot="pagination-bottom" slot-scope="props">
            <div class="d-flex justify-content-between flex-wrap">
              <div class="d-flex align-items-center mb-0 mt-1">
                <span class="text-nowrap ">
                  Mostrando 1 de
                </span>
                <b-form-select v-model="pageLength" :options="['25', '50', '100']" class="mx-1"
                  @input="(value) => props.perPageChanged({ currentPerPage: value })" />
                <span class="text-nowrap"> of {{ props.total }} registros </span>
              </div>
            </div>
          </template>
        </vue-good-table>
        <div class="d-flex justify-content-center  mt-2 mb-1"><b-button @click="exportCSV" class="bg-primary w-50"> Exportar
          CSV</b-button></div>
        <AddButton preTitle="Agregar Infraestructura" goTo="advance-infrastructure"  v-if="!isAdmin()"/>
      <ControlMenu />
      </div>
    </div>
  </template>
  
  <script>
  import ControlMenu from '@/components/ControlMenu.vue'
  import HeaderBar from '@/components/HeaderBar.vue'
  import vSelect from 'vue-select'
  import "vue-select/dist/vue-select.css";
  import { ValidationProvider, ValidationObserver } from 'vee-validate'
  import {
    BAvatar, BBadge, BPagination, BFormGroup, BFormSelect, BFormCheckbox, BDropdown, BDropdownItem, BRow, BCol, BLink, BCardBody, BCard, BButton, BForm, BFormInput, BInputGroup, BImg, BCardTitle, BCardText,
  } from 'bootstrap-vue'
  import { VueGoodTable } from 'vue-good-table'
  import AddButton from '@/components/AddButton.vue'

  export default {
    components: {
      BRow,
      BImg,
      BCol,
      BLink,
      BButton,
      BForm,
      BCardText,
      BCardTitle,
      BFormCheckbox,
      BInputGroup,
      BCardBody,
      BCard,
      VueGoodTable,
      vSelect,
      ValidationProvider,
      ValidationObserver,
      BFormCheckbox,
      BAvatar,
      BBadge,
      BPagination,
      BFormGroup,
      BFormInput,
      BFormSelect,
      BDropdown,
      BDropdownItem,
      ControlMenu,
      HeaderBar,
      AddButton,  
    },
    data() {
      return {
        currentLevelAccess: localStorage.getItem("currentLevelAccess"),
        fincaName:localStorage.getItem('currentFarmName'),
        currAmimal:0,
        pageLength: 25,
        dir: false,
        status1: null,
        status2: null,
        modalShow: false,
        modalCase: 0,
        editShow:false,
        modalTrashShow:false,
        columns: [
        {
            label: 'ID',
            field: 'id',
          },  
        {
            label: 'Tipo',
            field: 'infrastructure',
          },
          {
            label: 'Meses',
            field: 'construction_time',
          },
          {
            label: 'Precio',
            field: 'amount',
          },
          {
            label: '',
            field: 'action',
          },
  
        ],
        rows: [],
        InfrastructuresView:[],
        animal:{
          weight:0,
          age:0,
        },
        
      }
    },
    computed: {
      statusVariant() {
        const statusColor = {
          /* eslint-disable key-spacing */
          Current: 'light-primary',
          Professional: 'light-success',
          Rejected: 'light-danger',
          Resigned: 'light-warning',
          Applied: 'light-info',
          /* eslint-enable key-spacing */
        }
  
        return status => statusColor[status]
      },

    },
    methods:{
      isAdmin() {
        return this.currentLevelAccess === "Visualizador";
      },
      async fetchInfrastructures(config){
        let farmId= localStorage.getItem('currentFarm');
        fetch(this.$apiUrl+"list/InfrastructuresView2?farm_id="+farmId, config)
          .then(response => response.json())
          .then(result => {
              console.log(result)
              console.log(result.InfrastructuresView2);
              this.rows = result.InfrastructuresView2.map(item => {return {id:item.id,infrastructure:item.infrastructure,construction_time:item.construction_time,amount:item.amount}});
              console.log(this.rows);
          })
      },

      delStructure(idItem){
        const token = localStorage.getItem("accessToken");
        const config = {headers: {"X-Authorization": `Bearer ${token}`}};
        let self=this;

        this.$swal({
          title: 'Eliminar registro',
          text: '¿Seguro que desea eliminar el registro?',
          type: 'warning',
          icon:'warning',
          showCancelButton: false,
          confirmButtonText:'Si',
          showDenyButton: true,
          denyButtonText:'No',
          confirmButtonColor:'#5E8F23',
          showCloseButton: false,
          showLoaderOnConfirm: false  
        }).then((result)=>{
          if(result.isConfirmed){
            this.$http.get(this.$apiUrl+'delete/infrastructures/'+idItem,config)
            .then(function(){
              self.$router.go(0);
            });
          }
        });
      },
      exportCSV() {
        const myLogs = this.arrayToCsv(this.rows);
        this.downloadBlob(myLogs, './animales_export.csv', 'text/csv;charset=utf-8,%EF%BB%BF;');
        console.log("Logs has been saved");
      },
      arrayToCsv(data) {
        // Obtener el orden y los nombres de las columnas
        const orderedColumns = this.columns.filter(col => !col.hidden && col.field !== 'actions'); // Filtrar columnas ocultas
        const headers = orderedColumns.map(col => col.label); // Obtener los nombres de las columnas

        // Crear el contenido del CSV
        const csvContent = [
            headers.join(','), // Encabezados
            ...data.map(row => {
                return orderedColumns.map(col => row[col.field]).join(','); // Filtrar los valores según el orden de las columnas
            })
        ].join('\n');

        return csvContent;
      },
      downloadBlob(content, filename, contentType) {
        // Create a blob
        var blob = new Blob([content], { type: contentType });
        var url = URL.createObjectURL(blob);
  
        // Create a link to download it
        var pom = document.createElement('a');
        pom.href = url;
        pom.setAttribute('download', filename);
        pom.click();
      },
      
      
    },
    created() {
      const token = localStorage.getItem("accessToken");
      const config = {headers: {"X-Authorization": `Bearer ${token}`}};
      this.fetchInfrastructures(config);
    },
  }
  </script>
  <style>
  body {
    background-color: white !important;
  }
  
  table{
    width: 100% !important;
  }
  .vgt-responsive{
  overflow-x: auto;
  -webkit-overflow-scrolling: touch; 
}
  .subTitle {
    font-weight: 600;
    font-size: 23px;
  
  }
  
  .linkTitle {
  
    font-weight: 500;
    font-size: 14px;
    text-align: center;
    letter-spacing: 0.4px;
    color: #5E8F23;
  
  }
  
  .headTitle {
    font-weight: 600;
    font-size: 24px;
    color: #5E8F23;
  }
  
  thead{
    background-color: #5E8F23;
    text-align:center;
    color:#ffffff;
  }
  thead> tr{
    padding:5px;
  }
  .editAnimal {
    font-weight: 500;
    font-size: 18px;
  }
  
  
  .editModal {
    font-weight: 500;
    font-size: 18px;
  }
  
  span.text-center{
    display:flex;
    justify-content: center;
    text-align: center;
  }
  </style>